import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './index.scss';

// This is a component that handles showing one slide at a time
// from a collection of components that get passed as props and
// makes sure it shows the right transition... Nothing more.
class Slideshow extends PureComponent {

    constructor(props) {
        super(props);

        // We set the state to a prop because this is one of those cases
        // where we need this to seed the initial value. All remaining prop
        // changes get validated via compWillReceiveProps.
        this.state = {
            curr: props.selectedIndex,
            prev: null
        };

        // Bindings
        this.handleClick = this.handleClick.bind(this);
        this.renderSlide = this.renderSlide.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        const { selectedIndex, onChange } = nextProps;

        // If the same selectedIndex is passed as props, do not update the state
        if (selectedIndex === this.state.curr) {
            return;
        }
        this.setState((prevState) => ({
            curr: selectedIndex,
            prev: prevState.curr
        }));

        // Trigger an event when the current slide changes
        onChange && onChange(selectedIndex, this.props.selectedIndex);
    }

    handleClick(e) {
        e && e.preventDefault();
        const { onClick, selectedIndex } = this.props;
        typeof onClick === 'function' && onClick(selectedIndex);
    }

    // We use this function to create the "slides" that wrap the passed
    // components.
    renderSlide(component, index) {
        const { curr, prev } = this.state,
            classes = classNames('slideshow-slide', {
                current: index === curr,
                previous: index === prev
            });

        return (
            <div key={index} className={classes}>{ component }</div>
        );
    }

    // Render is just a wrapper for the "slides" with css classes that
    // dictate the transition between slides.
    render() {
        const { children, transition } = this.props,
            { curr, prev } = this.state,
            len = children.length,
            slideComponents = children.map(this.renderSlide),

            reverse = ( // Do reverse sliding when...
                (curr < prev) || // moving to a "lower" slide on the list...
                (curr === len - 1 && prev === 0) // or moving from the first slide to the last slide...
            ) && !( // but not when...
                (prev === len - 1 && curr === 0) //  moving from the last slide to the first slide
            ),

            classes = classNames('slideshow-component', transition, {
                'do-not-animate': prev === null, // Disable animations on first render
                reverse
            });

        return (

            <div className={classes} onClick={this.handleClick}>{ slideComponents }</div>
        );
    }
}

Slideshow.propTypes = {
    children: PropTypes.node.isRequired,
    selectedIndex: PropTypes.number,
    transition: PropTypes.string,
    onChange: PropTypes.func,
    onClick: PropTypes.func
};

Slideshow.defaultProps = {
    children: [],
    selectedIndex: 0,
    transition: 'slide-h',
    onChange: null,
    onClick: null
};

export default Slideshow;
